import { ImNewTab } from "react-icons/im";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function OpenInNewTabIcon({
  toolTipText = "Avaa koko ruutuun",
  url = "/",
  ...props
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (url) navigate(url);
  };

  if (toolTipText == null || toolTipText == "" || toolTipText == undefined)
    return <Icon {...props} onClick={handleClick} aria-label={toolTipText} />;

  return (
    <Tooltip title={toolTipText} placement="top" disableInteractive>
      <Icon {...props} onClick={handleClick} aria-label={toolTipText} />
    </Tooltip>
  );
}

export function OpenInNewTabIconButton({
  toolTipText = "Avaa koko ruutuun",
  url = "/",
  iconProps = {},
  iconButtonProps = {},
  onClick = null,
}) {
  const navigate = useNavigate();
  const handleClick = async () => {
    if (onClick) await onClick();
    navigate(url);
  };
  return (
    <Tooltip title={toolTipText} placement="top" disableInteractive>
      <IconButton
        {...iconButtonProps}
        onClick={handleClick}
        aria-label={toolTipText}
      >
        <Icon {...iconProps} />
      </IconButton>
    </Tooltip>
  );
}
OpenInNewTabIconButton.propTypes = {
  toolTipText: PropTypes.string,
  url: PropTypes.string,
  iconProps: PropTypes.object,
  iconButtonProps: PropTypes.object,
  onClick: PropTypes.func,
};

function Icon(props) {
  return <ImNewTab {...props} />;
}

OpenInNewTabIcon.propTypes = {
  toolTipText: PropTypes.string,
  url: PropTypes.string,
};
